module.exports = __webpack_public_path__ + "static/media/Apple iPhone 8 Plus Space Grey.540ea24a.png";